import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'table-basic-widget',
  templateUrl: './table-basic-widget.component.html',
  styleUrls: ['./table-basic-widget.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class TableBasicWidgetComponent implements OnInit {

@Input() title = 'Dist. Costos Nomina';
@Input() detail = 'Ref Doc: 152108';
@Input() total = '67645500';

dataTable = [
  {concepto: 'Base Salario', estado: 'Liq' , valor: '58042500'},
  {concepto: 'Prestaciones', estado: 'Liq' , valor: '8000500'},
  {concepto: 'Seguridad Social', estado: 'Liq' , valor: '1602500'}
];



  constructor() { }

  ngOnInit() {
  }

}
